'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { createClient } from '@/lib/supabase/client'

export function PostHogIdentifier() {
    useEffect(() => {
        const identifyUser = async () => {
            const supabase = createClient()
            const { data: { user } } = await supabase.auth.getUser()

            if (typeof window !== 'undefined' && user) {
                posthog.identify(user.id, {
                    email: user.email,
                    created_at: user.created_at
                })
            }
        }

        identifyUser()
    }, [])

    return null
}
